module.exports = __webpack_public_path__ + "img/outBg.cded0654.png";